"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const shared_1 = require("../../shared");
const getValueByPathFromUnknown_1 = __importDefault(require("../../shared/getValueByPathFromUnknown"));
const getDbPathFromArrayOfValues_1 = __importDefault(require("../../applicationFunctionality/getDbPathFromArrayOfValues"));
const valueIsNullOrUndef_1 = __importDefault(require("../../typeAssertions/valueIsNullOrUndef"));
const valueIsArray_1 = __importDefault(require("../../typeAssertions/valueIsArray"));
const valueIsRecord_1 = __importDefault(require("../../typeAssertions/valueIsRecord"));
const cleanDatabasePath_1 = __importDefault(require("../../FirebaseDatabaseCache/cleanDatabasePath"));
const AppStateConstants_1 = require("../../types/AppStateConstants");
const appStateSelectLocalStorageData_1 = __importDefault(require("../../shared/appStateSelectLocalStorageData"));
const localStorageGetData = async ({ store, functionId, entryVars: { pathOnLS: arrayPath, isRealTime }, callbacks, executeProcesses, }) => {
    let pathOnLS;
    const onEnd = (data) => {
        executeProcesses(functionId, callbacks.onEnd, data);
    };
    try {
        pathOnLS = (0, getDbPathFromArrayOfValues_1.default)(arrayPath);
    }
    catch (error) {
        const errorMessage = (0, getValueByPathFromUnknown_1.default)(error, ['message']);
        executeProcesses(functionId, callbacks.errorProcess, errorMessage);
        onEnd();
        return;
    }
    const localStorageData = (0, appStateSelectLocalStorageData_1.default)(store.getState());
    const data = (0, getValueByPathFromUnknown_1.default)(localStorageData, (0, cleanDatabasePath_1.default)(pathOnLS).split('/'));
    const listener = (newData) => {
        if ((0, valueIsNullOrUndef_1.default)(newData)) {
            executeProcesses(undefined, callbacks.onNoData);
        }
        else if (((0, valueIsArray_1.default)(newData) || (0, valueIsRecord_1.default)(newData))
            && (0, shared_1.objectIsEmpty)(newData)) {
            executeProcesses(undefined, callbacks.onNoData);
        }
        else {
            executeProcesses(functionId, callbacks.successProcess, newData);
        }
        onEnd(newData);
    };
    listener(data);
    if (isRealTime) {
        store.dispatch({
            type: AppStateConstants_1.AppStateConstants.LOCAL_STORAGE_ADD_LISTENER,
            payload: {
                path: pathOnLS,
                listener,
            },
        });
    }
};
exports.default = localStorageGetData;
